import { Tabs } from "antd";
import "../styles/Tabs.css";

const CustomTabs = ({ tabs = [], activeTab, setActiveTab }) => {
    const items = tabs.map((t) => ({
        key: t.key,
        label: (
            <div className="tab-label">
                {t.icon}
                <span>{t.label}</span>
            </div>
        ),
    }));

    return (
        <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={items}
            className="custom-ant-tabs"
        />
    )
}

export default CustomTabs